import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { userProfileHome } from "@/lib/accountProfiles";

export default function ProfileHomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={userProfileHome(user)} replace />;
}
